import ptBrAdmin from './admin/pt-br';
import enUsAdmin from './admin/en-us';

const translations =  {
  'pt-BR': ptBrAdmin,
  'en-US': enUsAdmin,
};


export default translations;